module.exports = __webpack_public_path__ + "img/rural2.6ba049b5.jpg";